import React, { createContext, useState, useContext, useEffect } from "react";

// Create a Context for location
const LocationContext = createContext();

// Create a Provider component
export const LocationProvider = ({ children }) => {
    const [location, setLocation] = useState({
        stateId: "",
        cityId: "",
        districtId: "",
        localityId: "",
        type: "",
    });

    //   useEffect(()=>{
    //     setLocation({
    //         stateId: '',
    //         cityId: localStorage.getItem("cityId"),
    //         districtId: '',
    //         localityId: localStorage.getItem("localityId"),
    //         type: localStorage.getItem("type")
    //     })
    //   },[])

    return (
        <LocationContext.Provider value={{ location, setLocation }}>
            {children}
        </LocationContext.Provider>
    );
};

// Custom hook to use location context
export const useLocation = () => {
    const context = useContext(LocationContext);
    if (!context) {
        throw new Error("useLocation must be used within a LocationProvider");
    }
    return context;
};
